import React from 'react';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import { useFirebaseDB } from '../../Core/hooks/useFirebaseDB';

const SideMenuNotificationBadgeBase = position => {
  const loggedAccount =
    sessionStorage.isTeamMember === 'true'
      ? sessionStorage.teamMemberId
      : sessionStorage.userId;

  const firebasePath = `humanCentric/conversations/${sessionStorage.userId}/stats/unreadMessages/${loggedAccount}`;
  const [totalUnreadMessages] = useFirebaseDB({ path: firebasePath });

  // Fallback: use cached count from sessionStorage
  const cachedCount = () => {
    const cached = sessionStorage.getItem('clientsWithUnreadMessagesCount');
    return cached ? parseInt(cached, 10) : 0;
  };

  // Live Firebase count (preferred if available)
  const liveCount = totalUnreadMessages?.clientsWithUnreadMessagesCount;

  const countToUse = typeof liveCount === 'number' ? liveCount : cachedCount;

  // Cache the new live value if it's valid
  if (typeof liveCount === 'number') {
    sessionStorage.setItem(
      'clientsWithUnreadMessagesCount',
      JSON.stringify(liveCount)
    );
  }

  const shouldShow = countToUse > 0;

  const countLabel = countToUse > 99 ? '99+' : countToUse;

  const commonStyle = {
    backgroundColor: '#B3261E',
    color: '#FFFFFF',
    borderRadius: '8px',
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: '0.7px',
    fontFamily: `Roboto, sans-serif`,
    textTransform: 'uppercase',
  };

  const inlineStyle = {
    ...commonStyle,
    padding: '0.5px 5.5px',
  };

  const absoluteStyle = {
    ...commonStyle,
    padding: '3px 5.5px',
  };

  return shouldShow ? (
    <span style={position === 'absolute' ? absoluteStyle : inlineStyle}>
      {countLabel ?? '99+'}
    </span>
  ) : null;
};

SideMenuNotificationBadgeBase.propTypes = exact({
  position: PropTypes.string,
});

export const SideMenuNotificationBadge = React.memo(
  SideMenuNotificationBadgeBase
);
SideMenuNotificationBadge.displayName = 'SideMenuNotificationBadge';
